<mat-select
  panelClass="entity-select-component-select-panel"
  class="entity-select-component-select mat-form-field-animations-enabled"
  [ngModel]="selectedItem()"
  (ngModelChange)="selected.emit($event)"
  [compareWith]="compareFn()"
>
  <mat-select-trigger class="select-trigger">
    <span [title]="displayFn()(selectedItem())">{{ displayFn()(selectedItem()) }}</span>
  </mat-select-trigger>
  <div class="search-container">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <input
        matInput
        [formControl]="searchControl"
        [placeholder]="placeholder() | translate"
        (keydown)="$event.stopPropagation()"
      />
      @if (searchControl.value) {
        <button mat-icon-button matSuffix type="button" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  @for (item of items(); track $index) {
    <mat-option [value]="item" [title]="displayFn()(item)">
      {{ displayFn()(item) }}
    </mat-option>
  }

  @if (loading()) {
    <mat-option disabled>
      <mat-spinner diameter="20" />
    </mat-option>
  }
</mat-select>
